import { useSearchParams } from "react-router";
import { useTranslation } from "react-i18next";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogAction,
} from "~/atoms/alert-dialog";

const SsoModals = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const ssoLinked = searchParams.get("ssoStatus") === "linked";
  const ssoError = searchParams.get("ssoStatus") === "error";
  const ssoConflict = searchParams.get("ssoStatus") === "conflict";
  const ssoEmail = searchParams.get("ssoEmail") ?? "";

  const handleCloseModal = () => setSearchParams(undefined);

  const isOpen = ssoLinked || ssoError || ssoConflict;

  const getTitle = () => {
    if (ssoLinked) return t(($) => $.password.sso.linked.title);
    if (ssoError) return t(($) => $.password.sso.error.title);
    if (ssoConflict) return t(($) => $.password.sso.conflict.title);
    return "";
  };

  const getDescription = () => {
    if (ssoLinked) return t(($) => $.password.sso.linked.description);
    if (ssoError) return t(($) => $.password.sso.error.description);
    if (ssoConflict) {
      const part1 = t(($) => $.password.sso.conflict.description1);
      const part2 = t(($) => $.password.sso.conflict.description2);
      return `${part1} ${ssoEmail} ${part2}`;
    }

    return "";
  };

  return (
    <AlertDialog open={isOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{getTitle()}</AlertDialogTitle>
          <AlertDialogDescription className="py-4">
            {getDescription()}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={handleCloseModal}>
            {t(($) => $.commons.buttons.confirm)}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default SsoModals;
